import { saveAs } from 'file-saver';
import RestService from '../services/rest';

async function getSolicitations(searchType) {
  return RestService.postAuthenticated(
    `panel/solicitations?searchType=${searchType}`,
  );
}

async function solicitationUserClient(solicitationId) {
  return RestService.getAuthenticated(`panel/solicitations/new-client?solicitation=${solicitationId}`);
}

async function solicitationApproveUse(solicitationId, data) {
  return RestService.postAuthenticated(`panel/solicitations/approve?solicitation=${solicitationId}`, data);
}

async function updateStatusSolicitations(solicitationId, solicitationStatus) {
  return RestService.putAuthenticated('panel/solicitations/update', { solicitationId, solicitationStatus });
}

async function getCsvSolicitationsReport() {
  const response = await RestService.getAuthenticated('panel/solicitations/report/csv', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'solicitations-export.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function downloadImage(imageName) {
  saveAs(imageName, imageName);
}

async function uploadImages(
  file,
  name,
  imageToChange,
  clientId,
  userId,
  stateToUpdate,
  solicitation,
  idSolicitation,
) {
  const fd = new FormData();
  fd.append('file', file);
  return RestService.postAuthenticated(
    `solicitations/change?&name=${name}&imageToChange=${imageToChange}`
  + `&clientId=${clientId}&userId=${userId}&typeImage=${stateToUpdate}`
  + `&solicitation=${solicitation}&idSolicitation=${idSolicitation}`,
    fd,
    {
      'Content-Type': 'multipart/form-data',
    },
  );
}

export default {
  getSolicitations,
  solicitationUserClient,
  solicitationApproveUse,
  getCsvSolicitationsReport,
  updateStatusSolicitations,
  downloadImage,
  uploadImages,
};
